/**
 * Select props
 *
 * @param {String} id - The id of the select
 * @param {String} value - The value of the select
 * @param {String} name - The name of the select
 * @param {String} inputClass - The input class of the select
 * @param {Array} selectOptions - The select options of the select
 */
export const SelectProps = {
  id: {
    required: true,
    type: String,
    default: '',
  },
  value: {
    type: String,
    default: '',
  },
  name: {
    required: true,
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '-- Choose --',
  },
  inputClass: {
    type: String,
    default: 'select2',
  },
  options: {
    type: Array,
    default: () => [],
  },
  select2: {
    type: Object,
    default: () => {},
  },
  handleSelect2AjaxData: {
    type: Function,
  },
  handleSelect2AjaxProcessResults: {
    type: Function,
  },
};

/**
 * Transform options
 * - This function is used to transform the options.
 * - Sometimes we need to send the props.value in form of post object to the select component.
 * - Some scenarios when sending the props.value in form of post object are:
 *   - When the select is a single post type, we need to send the post object as initial value.
 *
 * @param {Object} props - The props of the select
 * @returns {Array} The default options
 */
export const transformOptions = (props) => {
  // Transform options if it's a post object.
  if (typeof props.value === 'object' && props.value?.ID) {
    return [
      {
        id: props.value.ID,
        text: `${props.value.post_title} #${props.value.ID} (${props.value.post_type})`,
      },
    ];
  }

  return props.options;
};

/**
 * Transform value
 *
 * @param {Object} props - The props of the select
 * @returns {String} The transformed value
 */
export const transformValue = (props) => {
  // Transform value if it's a post object.
  if (typeof props.value === 'object' && props.value?.ID) {
    return props.value.ID;
  }

  return props.value;
};

/**
 * Initialize select
 *
 * @param {Object} props - The props of the select
 */
export const initSelect2 = (props) => {
  if (props.inputClass.includes('select2') || props.select2) {
    jQuery(document).ready(() => {
      let select2 = props.select2 || {};

      // Set placeholder.
      select2.placeholder = select2.placeholder || props.placeholder;

      // Check if select2 has ajax
      if (select2.ajax) {
        // Select2 default data function.
        const defaultDataFunction = function (params) {
          // Set default params
          let select2params = {
            q: params.term,
          };

          // Check if select2 has action
          if (select2.ajax.action) {
            select2params.action = select2.ajax.action;
          }

          return select2params;
        };

        // Select2 default process results function.
        const defaultProcessResultsFunction = function (data) {
          return {
            results: data.map(function (post) {
              return {
                id: post.id,
                text: `${post.text} #${post.id} (${post.post_type})`,
              };
            }),
          };
        };

        // Define select2 ajax.
        select2.ajax.data = props.handleSelect2AjaxData || defaultDataFunction;
        select2.ajax.processResults = props.handleSelect2AjaxProcessResults || defaultProcessResultsFunction;
      }

      // Initialize select2
      let selectedValue = transformValue(props);
      let select2Input = jQuery(`#field_${props.id}`);
      if (select2Input.data('select2')) select2Input.select2('destroy');
      select2Input.select2(select2).val(selectedValue).trigger('change');

      // Trigger change event on select if jquery select2 is change
      select2Input.on('select2:select', function (e) {
        // Trigger change event on select
        const inputElement = document.getElementById(`field_${props.id}`);
        inputElement.value = jQuery(this).val();
        const event = new Event('change', {
          bubbles: true, // Event bubbles up through the DOM
          cancelable: true, // Event can be cancelled
        });
        inputElement.dispatchEvent(event);
      });
    });
  }
};

/**
 * Destroy select
 *
 * @param {Object} props - The props of the select
 */
export const destroySelect2 = (props) => {
  const DOM = jQuery(`#field_${props.id}`);
  if (props.inputClass.includes('select2') || props.select2 || DOM.data('select2')) {
    DOM.select2('destroy');
    DOM.empty();
  }
};
